<template>
   <div id="app">
		<Detail v-if="popup === 'detail'" @onClose="closePopup" />
		<Noticepopup v-if="popup === 'notice'" :notice="data" @onClose="closePopup" />
		<Nav />
		<div class="category" id="home">
			<div class="slider-box">
				<div class="slider" v-for="(item, idx) in slider" :key="idx" :style="{ opacity: opacity === idx ? 1 : 0 }">
					<div class="book-info">
						<p class="title">{{ item.title }}</p>
						<p class="text">{{ item.text }}</p>
						<p class="author">- {{ item.author }} -</p>
					</div>
					<img :src="item.img" class="cover" />
				</div>
			</div>
		</div>
		<div class="category introduce" id="introduce">
			<div class="half1">
				<p class="introduce-text">
					<span><b class="yellow">레몬</b><b class="green">트리</b>북스</span>는<br> 로맨스 소설 전문 전자책 출판사입니다.<br>
					책을 통해 여러분의 삶에 작은 행복을 전하고자 합니다.
				</p>
			</div>
		</div>
		<div class="category newbook" id="book">
			<div class="white">
				<h2 class="newbook-title">새로운 책</h2>
				<div class="all-book">
					<div class="book" v-on:click="openBook">
						<img src="./assets/small-book.jpg"/>
						<div class="coming">
							<p>출간 예정</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="category contact" id="contact">
			<h2 class="newbook-title">공지사항</h2>
			<table class="notice-board">
				<thead>
					<tr>
						<th>#</th>
						<th>제목</th>
						<th>날짜</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in notice" :key="idx">
						<td>{{ idx + 1 }}</td>
						<td v-on:click="clickNoti(item)">{{ item.title }}</td>
						<td>{{ convertDate(item.date) }}</td>
					</tr>
				</tbody>
			</table>
			<footer>
				<p>
					레몬트리북스 | 대표자: 임꺽정 | 사업자등록번호: 420-76-77888<br>
					주소: 경기도 부천시 옥산로 7 | TEL: 032-327-4488 | E-MAIL: lemontreebooks@naver.com
				</p>
				<p>Copyright (c) LEMONTREEBOOKS. All Rights Reserved.</p>
			</footer>
		</div>
   </div>
</template>
<script>
import Nav from './components/Nav';
import Noticepopup from './NoticePopup';
import Detail from './Detail';
import dateMix from './mixin/date';
import db from './config';
import slider from './json/slider';

export default {
	name: 'Home',
	components: {
		Nav,
		Detail,
		Noticepopup
	},
	mixins: [ dateMix ],
	data: function () {
		return {
			position: 0,
			notice: [],
			popup: '',
			data: {},
			timer: null,
			opacity: 1,
			idx: 0,
			slider: [...slider.list],
			selected: {
				title: '',
				img: '',
				text: ''
			}
		};
	},
	created() {
		let arr = [];
		window.addEventListener('wheel', this.scrollAuto, { passive: false, capture: 'bubble' });
		db.collection('notice').get().then((querySnapshot) => {
			querySnapshot.forEach((doc) => {
				arr.push(doc.data());
			});
			arr.sort((a, b) => {
				return b.date - a.date;
			})
			this.notice = arr;
		});
	},
	mounted() {
		window.scrollTo({ top: (Math.ceil(document.documentElement.scrollTop / 937) * 937), left: 0, behavior: 'smooth' });
		this.selected = slider.list[0];
		this.fadeEffect();
	},
	methods: {
		fadeEffect() {
			this.opacity = 0;
			++this.idx;
			if (this.idx === this.slider.length) {
				this.idx = 0;
			}
			this.opacity = this.idx;
			setTimeout(() => this.fadeEffect(), 3000);
		},
		scrollAuto(e) {
			e.preventDefault();
			e.stopPropagation();
			const height = window.innerHeight;

			if (e.deltaY < 0) {
				if (this.position === 0) {
					return ;
				}
				this.position -= height;
			} else if (e.deltaY > 0) {
				if (this.position === height * 4) {
					return ;
				}
				this.position += height;
			}
			window.scrollTo({ top: this.position, left: 0, behavior: 'smooth' });
		},
		closePopup(keyword) {
			this.popup = keyword;
		},
		writeNotice(data) {
			db.collection('notice').add(data).then((docRef) => {
				console.log(docRef.id);
				this.popup = '';
			}).catch((error) => {
				console.error(error);
			});
		},
		openBook() {
			this.popup = 'book';
		},
		clickNoti(item) {
			this.data = item;
			this.popup = 'notice';
		}
	}
}
</script>
<style>
.btn-box {
	width: 1000px;
	margin: 0 auto;
	padding-top: 30px;
}
#home {
	background-image: url(./assets/treeframe.png);
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
}
.btn-box button {
	margin-left: auto;
	display: block;
	background-color: rgb(100, 157, 102);
	color: white;
	border: none;
	padding: 5px 15px;
}
.coming {
	background-color: rgba(0, 0, 0, 0.7);
	height: 60px;
	position: absolute;
	bottom: 4px;
	right: 0;
	width: 100%;
	color: white;
}
.coming p {
	text-align: center;
	padding-top: 20px;
}
.category {
	height: 100vh;
	width: 100vw;
	position: relative;
}
.half1 {
	width: 100%;
	height: 100%;
	position: relative;
	background-image: url(./assets/bg.jpg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
.half2 {
	width: 70%;
	height: 100%;
	background-color: #f6f578;
}
.yellow {
	color: rgb(246, 245, 120);
}
.green {
	color: #06623b;
}
.introduce {
	display: flex;
}
.newbook {
	background-color: rgb(246, 245, 120);
}
.all-book {
	display: flex;
	justify-content: center;
}
.book {
	position: relative;
}
.book img {
	width: 250px;
}
footer {
	background-color: #06623b;
	color: white;
	font-size: 13px;
	padding: 50px;
	line-height: 1.5;
	text-align: left;
	width: 100%;
	position: absolute;
	bottom: 0;
	left: 0;
}
.introduce-text {
	font-size: 30px;
	position: absolute;
	bottom: 15%;
	left: 20%;
	width: 800px;
	text-align: left;
	line-height: 2;
}
.introduce-text span {
	font-size: 60px;
}
.newbook-title {
	padding-top: 200px;
	padding-bottom: 100px;
	font-size: 45px;
	font-weight: 900;
}
.notice-board {
	width: 1000px;
	margin: 0 auto;
	text-align: center;
}
.notice-board thead {
	background-color: #649d66;
}
.notice-board th {
	padding: 5px 0;
	color: white;
	font-weight: 300;
}
.notice-board td {
	padding: 5px 0;
	font-size: 15px;
}
.notice-board tbody tr:hover {
    background-color: rgb(246, 245, 120, 0.5);
    cursor: pointer;
}
.slider {
	width: 1000px;
	height: inherit;
	transition: opacity 1s;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 0 auto;
	position: absolute;
	left: 0;
	top: 0;
}
.slider .title {
	font-size: 50px;
	color: white;
	-webkit-text-stroke: 1px purple;
	text-shadow: 3px 3px 2px darkgrey;
}
.slider .text {
	font-size: 20px;
	margin-top: 30px;
	line-height: 1.5;
	white-space: pre-wrap;
	word-break: keep-all;
}
.slider .cover {
	width: 500px;
}
.book-info {
	padding-right: 30px;
}
.book-info .author {
	padding-top: 50px;
}
.slider-box {
	margin: 0 auto;
	width: 1000px;
	position: relative;
	height: inherit;
}
.white {
	background-color: white;
	width: 100vw;
	height: 50%;
}
/* phone */
@media screen and (max-width: 414px) {
	.slider {
		flex-direction: column-reverse;
		width: 100vw;
		justify-content: initial;
	}
	.slider-box {
		width: 100vw;
		height: initial;
	}
	.slider .cover {
		width: 60vw;
		height: auto;
		margin-top: 5vh;
	}
	.slider .title {
		font-size: 30px;
		padding-top: 30px;
	}
	.slider .text {
		margin: 0;
		padding: 0 5vw;
	}
	.book-info {
		padding: 0;
	}
	.slider .author {
		padding-top: 10px;
	}
	.introduce-text {
		left: 0;
		bottom: 40vh;
		text-align: center;
		width: 100vw;
		padding: 0 3vw;
		font-size: 25px;
		word-break: keep-all;
	}
	.introduce-text span {
		text-align: center;
		font-size: 45px;
	}
	.newbook-title {
		padding-top: 10vh;
	}
	.book img {
		width: 60vw;
	}
	.notice-board {
		width: 100vw;
	}
	.notice-board tr td:nth-child(1), .notice-board tr th:nth-child(1), .notice-board tr td:nth-child(3), .notice-board tr th:nth-child(3) {
		display: none;
	}
	footer {
		padding: 7vw;
	}
}
/* tablet portrait 세로 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portait) {
	.slider {
		flex-direction: column-reverse;
		width: 100vw;
		justify-content: center;
	}
	.slider-box {
		width: 100vw;
		height: initial;
	}
	.slider .cover {
		width: 50vw;
		height: auto;
		margin-top: 5vh;
	}
	.slider .title {
		font-size: 50px;
		padding-top: 30px;
	}
	.slider .text {
		margin: 0;
		padding: 0 5vw;
		font-size: 30px;
	}
	.book-info {
		padding: 0;
	}
	.slider .author {
		padding-top: 10px;
	}
	.introduce-text {
		left: 0;
		bottom: 40vh;
		text-align: center;
		width: 100vw;
		padding: 0 3vw;
		font-size: 30px;
		word-break: keep-all;
	}
	.introduce-text span {
		text-align: center;
		font-size: 50px;
	}
	.newbook-title {
		padding-top: 10vh;
	}
	.book img {
		width: 50vw;
	}
	.notice-board {
		width: 100vw;
	}
	footer {
		padding: 7vw;
	}
}
@media screen and (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) {

}
@media screen and (min-width: 717px) and (max-height: 512px) {
	.slider .cover {
		width: 30vw;
		height: auto;
	}
	.slider .title {
		font-size: 30px;
	}
	.slider {
		width: 100vw;
	}
	.introduce-text span {
		font-size: 40px;
	}
	.introduce-text {
		font-size: 25px;
		left: 10%;
		width: fit-content;
	}
	.book img {
		width: 20vw;
	}
	.newbook-title {
		padding-top: 10vh;
		font-size: 30px;
	}
	.notice-board {
		width: 100vw;
	}
	.slider-box {
		width: 100vw;
	}
}
</style>
